import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import ResidentDetailsTab from "../AddResident/ResidentDetailsTab";
// import { useNavigate } from "react-router-dom";
import AddResidentNewTab from "./AddResidentNewTab";

function AddResidentNew() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ResidentManagement")}
              />{" "} */}
              Add Resident
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Resident Details</div>
            <div className="residentContMain">
              <div className="newAddResidentMain">
                <AddResidentNewTab />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AddResidentNew;
